module.exports = __webpack_public_path__ + "static/media/Lab-tests.0fc1cbc7.webp";